import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getTeamManagementShelf } from '../selectors';
import { closeShelfCalled, managePermissionsFinished, wizardActionTypeChanged } from '../actions';
import TeamManagementShelf from '../components/TeamManagementShelf';

const mapStateToProps = state => getTeamManagementShelf(state);

const mapDispatchToProps = dispatch => {
    return bindActionCreators(
        {
            onCloseShelf: closeShelfCalled,
            onManagePermissionsFinished: managePermissionsFinished,
            onWizardActionTypeChanged: wizardActionTypeChanged,
        },
        dispatch
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(TeamManagementShelf);
